import { useParams } from "react-router-dom";
import { MyProjectAppBar } from "./myProjectAppBar";
import { ProjectCanvas } from "./projectCanvas";
import { useQuery } from "@tanstack/react-query";
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import React, { useState, useRef } from "react";
import { ProjectContext } from "../../contexts/ProjectContext";
import { ThemeProvider } from "@mui/material";
import { DeleteElementDialog } from "../Dialogs/deleteElementDialog";
import ProjectDrawer from "./Drawer/projectDrawer";
import { NewNodeDialog } from "../Dialogs/newNodeDialog";
import { ElementProperties } from './ElementProperties/elementProperties';
import { ProjectData } from "../../data/projectData";
import { ProjectSpeeddial } from './projectSpeeddial';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { ShowPropertiesButton } from './showPropertiesButton';
import defaultTheme from '../Themes/defaultTheme';
import { useNavigate } from "react-router-dom";
import { NewProjectDialog } from "../Dialogs/newProjectDialog";
import { LoadingCircle } from "../loading";
import { StyleLine, TypeLine } from "../../types";
import { NodeData } from "../../data/nodeData";
import { ElementData } from "../../data/elementData";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export const ProjectComponent = (props) => {
    const [elements, setElements] = useState([ElementData]);
    const [searchElements, setSearchElements] = useState([]);
    const [projectRef, setProjectRef] = useState();
    const [selectedItem, setSelectedItem] = useState(ProjectData);
    const [selectedItemId, setSelectedItemId] = useState(0);
    const [selectedItemType, setSelectedItemType] = useState("");
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showNewNodeDialog, setShowNewNodeDialog] = useState(false);
    const [showProjectDrawer, setShowProjectDrawer] = useState(false);
    const [showElementProperties, setShowElementProperties] = useState(false);
    const [notificationOpen, setNotificationOpen] = useState({ state: false, sev: "success", msg: "N/A" });
    const params = useParams();
    const canvasRef = useRef(null);
    const navigate = useNavigate();
    const [isPublicProject, setIsPublicProject] = useState(false);


    const { data: projectData, isLoading, isError } = useQuery({
        queryKey: ["loadproject"], queryFn: async () => {
            try {
                const docRef = doc(db, "project", params.id);
                const docSnap = await getDoc(docRef)

                setProjectRef(docRef);

                if (docSnap.exists()) {
                    setIsPublicProject(docSnap.data().isPublicProject);
                    if (!isPublicProject && !props.user) {
                        navigate("/login");
                    }
                    getElements(docSnap.data());
                    return docSnap.data();
                } else {
                    console.log("Error: Can't load project");
                }
            } catch (e) {
                console.log(e);
            }

        }
    });

    const saveProject = () => {
        console.log("saving project");
        console.log(projectData);
        updateDoc(projectRef, projectData)
            .then(() => {
                //setNotificationOpen({ state: true, sev: "success", msg: "Project saved" });
            })
            .catch(error => {
                setNotificationOpen({ state: true, sev: "error", msg: "Project saving failed!" })
            });
    }

    const getElements = (data) => {
        const loadedElements = [];
        if (!data.elements) {
            return [...loadedElements];
        }
        
        console.log([...data.elements]);

        setSearchElements(data.elements);
        setElements([...data.elements]);
        return [...data.elements];
    }

    const getNextElementId = () => {
        const ids = elements.map(element => {
            if (Number.isInteger(parseInt(element.data.id))) return parseInt(element.data.id);
            return 0;
        });

        const max = Math.max(...ids);
        return max + 1;
    }

    const addConnection = (sourceNodeId, targetNodeId, type, save) => {
        const newConnectionId = (targetNodeId !== undefined) ? (parseInt(targetNodeId)) + 1 : getNextElementId();
        console.log("targetNodeId: " + targetNodeId + ", newConnectionId: " + newConnectionId + ", sourceNodeId: " + sourceNodeId);
        
        let newConnection = {
            group: "edges",
            data: {
                id: newConnectionId,
                name: "label",
                edgetype: projectData.defaultedgetype
            }
        };

        if (type.toUpperCase() === "PARENT") {
            newConnection.data.source = parseInt(sourceNodeId);
            newConnection.data.target = parseInt(targetNodeId);
        }
        if (type.toUpperCase() === "CHILD") {
            newConnection.data.source = parseInt(targetNodeId);
            newConnection.data.target =parseInt(sourceNodeId);
        }

        console.log(newConnection);
        //if (newConnection.data) delete newConnection.data;
        var newnodes = [];
        newnodes.push(newConnection);

        if (!projectData.elements) {
            projectData.elements = [];
        }
        projectData.elements.push(newConnection);
        setElements(elements => [...elements, ...newnodes]);
        if (save === true) {
            saveProject();
        }

        return newConnection;
    }

    const addNode = (data, type) => {
        const newNodeId = getNextElementId();
        delete data.id;
        const newNode = {
            group: "nodes",
            data: {
                id: newNodeId,
                createdon: new Date().toUTCString(),
                ...data
            }
            // position:
            //     { x: (100), y: (100) },
        }
        console.log(newNode);
        var newnodes = [];
        newnodes.push(newNode);
        
        setElements(elements => [...elements, ...newnodes]);

        if (!projectData.elements) {
            projectData.elements = [];
        }

        projectData.elements.push(newNode);

        if (type.toUpperCase() !== "O") {
            addConnection(selectedItemId, newNodeId, type, false);
        }
        saveProject();
        console.log(elements);
    }

    const deleteElementDialog = (id) => {
        setShowDeleteDialog(true);
    }

    const closeDeleteElementDialog = () => {
        setShowDeleteDialog(false);
    }

    const deleteElement = () => {
        projectData.nodes = projectData.nodes.filter(el => { return el.id !== selectedItemId; });
        projectData.edges = projectData.edges.filter(el => { return el.id !== selectedItemId && el.source !== selectedItemId && el.target !== selectedItemId; });
        setElements(current => current.filter(el => { return el.data.id !== selectedItemId && el.data.source !== selectedItemId && el.data.target !== selectedItemId }));
        SelectItem("x");
        saveProject();
        //closeDeleteElementDialog();
    }

    const updateElement = (data) => {
        projectData.elements = projectData.elements.map(el => {
            if (el.data.id === selectedItem.data.id) {
                return {
                    ...el,
                    data: data
                };
            } else {
                return el;
            }
        });
        getElements(projectData);
        saveProject();
    }

    const updateElementImage = (url) => {
        projectData.elements = projectData.elements.map(el => {
            if (el.data.id === selectedItem.data.id) {
                return {
                    ...el,
                    style: {
                        "background-image": url
                    }
                };
            } else {
                return el;
            }
        });
        getElements(projectData);
        saveProject();
    }

    const updateProject = (data) => {
        console.log(data);
        if (!data) return;
        projectData.name = data.name;
        projectData.description = data.description;
        if (data.ispublic)
            projectData.ispublic = data.ispublic
        else
            projectData.ispublic = false;

        if (data.allowcomments)
            projectData.allowcomments = data.allowcomments
        else
            projectData.allowcomments = false;

        if (data.defaultshapetype)
            projectData.defaultshapetype = data.defaultshapetype
        else
            projectData.defaultshapetype = "circle";

        if (data.defaultedgetype)
            projectData.defaultedgetype = data.defaultedgetype
        else
            projectData.defaultedgetype = StyleLine[0].value;

        if (data.defaultconnectiontype)
            projectData.defaultconnectiontype = data.defaultconnectiontype
        else
            projectData.defaultconnectiontype = TypeLine[0].value;

        getElements(projectData);
        saveProject();
    }

    const SelectItem = (id) => {
        console.log("Selectujeme: " + id);
        if (id === 'x') {
            //setShowElementProperties(false);
            setSelectedItemId(-1);
        }
        else {
            setSelectedItemId(id);
            let node = projectData.elements.filter((el) => { return el.data.id == id; });
            if (node.length !== 0) {
                let a = node[0];
                a = {...node[0],
                    data: {...ElementData, ...node[0].data}
                }
                setSelectedItem(a);
                //setSelectedItem({...emptyNode, ...node});
                setSelectedItemType(node[0].group);
                if (!("ontouchstart" in document.documentElement)) {
                    setShowElementProperties(true);
                }
            }
            else {
                console.log("AU");
            }
        }
    }

    const getItem = () => {
        return projectData?.nodes?.filter(el => { return el.id === selectedItemId; });
    }

    const startConnection = () => {
        canvasRef.current.ConnectionStart();
    }

    const handloShowPropertiesButton = () => {
        setShowElementProperties(!showElementProperties);
    }

    const handleCloseSb = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setNotificationOpen({ state: false, sev: "success", msg: "N/A" });
    };

    if (isError) {
        return <h1>Error, sorry.</h1>
    }

    if (isLoading) {
        return (<LoadingCircle />);
    }

    return (
        <ProjectContext.Provider value={{ projectData, elements, setElements, getNextElementId, addNode, startConnection, addConnection, deleteElement, deleteElementDialog, SelectItem, setShowNewNodeDialog }}>
            <ThemeProvider theme={defaultTheme}>
                <MyProjectAppBar setProjectDrawerState={setShowProjectDrawer} elements={searchElements} canvasRef={canvasRef} selectedItem={selectedItemId} userData={props.userData} />
                <ProjectCanvas ref={canvasRef} />
                <ProjectDrawer state={showProjectDrawer} setState={setShowProjectDrawer} project={projectData} update={updateProject} canvasRef={canvasRef} />
                {/* <NewProjectDialog open={true}></NewProjectDialog> */}
                {/* <NewNodeDialog type={"PARENT"} open={showNewNodeDialog} handleClose={() => setShowNewNodeDialog(false)} handleAdd={addNode} refreshLayout={() => canvasRef.current.setLayout()} /> */}
                <DeleteElementDialog id={selectedItemId} name={getItem()?.label} handleDelete={deleteElement} open={showDeleteDialog} close={closeDeleteElementDialog} refreshLayout={() => canvasRef.current.setLayout()}  />
                <ShowPropertiesButton action={handloShowPropertiesButton} />
                <ElementProperties item={selectedItem} type={selectedItemType} open={showElementProperties} setOpen={setShowElementProperties} update={updateElement} updateImage={updateElementImage} projectData={projectData} projectId={params.id}></ElementProperties>
                {showElementProperties && <ProjectSpeeddial startConnection={startConnection} canvasRef={canvasRef} />}
                <Snackbar open={notificationOpen.state} autoHideDuration={6000} onClose={handleCloseSb}>
                    <Alert onClose={handleCloseSb} severity={notificationOpen.sev} sx={{ width: '100%' }}>
                        {notificationOpen.msg}
                    </Alert>
                </Snackbar>
            </ThemeProvider>
        </ProjectContext.Provider>
    );
};